/* rewards section */
  document.addEventListener('DOMContentLoaded', function() {

// FAQ Toggle functionality
    const faqQuestions = document.querySelectorAll('.faq-question');

    faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
        const toggle = question.querySelector('.toggle');
        const isExpanded = toggle.textContent === '-';

        toggle.textContent = isExpanded
          ? '+'
          : '-';
      });
    });

// FAQ Section Functionality
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      
      question.addEventListener('click', () => {
        const isExpanded = question.getAttribute('aria-expanded') === 'true';
        
        // Close all other items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
            otherItem.querySelector('.faq-answer').classList.remove('active');
          }
        });
        
        // Toggle current item
        question.setAttribute('aria-expanded', !isExpanded);
        answer.classList.toggle('active');
      });
    });

// Handle user points and tier progress
    const pointsElement = document.querySelector('.sweettooth-points-balance');
    
    // Update points display when loaded
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          const points = parseInt(pointsElement.textContent);
          if (!isNaN(points)) {
            // Points are now displayed directly from the server
            // No need for additional calculations
          }
        }
      });
    });
    
    // Start observing the points element
    if (pointsElement) {
      observer.observe(pointsElement, {
        characterData: true,
        childList: true,
        subtree: true
      });
    }

// Featured Products Slider
    const slider = document.querySelector('.featured-products-slider');
    const prevButton = document.querySelector('.slider-prev');
    const nextButton = document.querySelector('.slider-next');
    
    if (!slider || !prevButton || !nextButton) return;

    let currentPosition = 0;
    let wasMobile = window.innerWidth <= 768;
    let resizeTimeout;
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;

    function isMobileViewport() {
      return window.innerWidth <= 768;
    }

    function getDesktopMetrics() {
      const firstCard = slider.querySelector('.product-card');
      const container = slider.parentElement;

      if (!firstCard || !container) {
        return {
          stepWidth: 0,
          maxPosition: 0
        };
      }

      const cardStyles = window.getComputedStyle(firstCard);
      const stepWidth = firstCard.getBoundingClientRect().width
        + (parseFloat(cardStyles.marginLeft) || 0)
        + (parseFloat(cardStyles.marginRight) || 0);

      return {
        stepWidth,
        maxPosition: Math.min(0, container.clientWidth - slider.scrollWidth)
      };
    }

    function updateScrollIndicator() {
      const scrollIndicator = slider.querySelector('.scroll-indicator');
      const scrollThumb = slider.querySelector('.scroll-indicator-thumb');

      if (!scrollIndicator || !scrollThumb) return;

      if (!isMobileViewport()) {
        scrollIndicator.style.display = 'none';
        return;
      }

      const scrollableWidth = slider.scrollWidth - slider.clientWidth;

      if (scrollableWidth <= 0) {
        scrollIndicator.style.display = 'none';
        scrollThumb.style.left = '0%';
        return;
      }

      scrollIndicator.style.display = '';

      const visiblePortion = slider.clientWidth / slider.scrollWidth;
      const thumbWidth = Math.max(20, Math.min(80, visiblePortion * 100));
      scrollThumb.style.width = `${thumbWidth}%`;

      const progress = slider.scrollLeft / scrollableWidth;
      const position = progress * (100 - thumbWidth);
      scrollThumb.style.left = `${position}%`;
    }

    function updateSliderPosition() {
      const { maxPosition } = getDesktopMetrics();
      const isMobile = isMobileViewport();

      if (!isMobile) {
        currentPosition = Math.min(0, Math.max(currentPosition, maxPosition));
        slider.style.transform = `translateX(${currentPosition}px)`;
      } else {
        slider.style.transform = '';
      }

      const prevDisabled = isMobile || currentPosition === 0;
      const nextDisabled = isMobile || currentPosition <= maxPosition;

      prevButton.style.opacity = prevDisabled ? '0.5' : '1';
      prevButton.style.pointerEvents = prevDisabled ? 'none' : 'auto';
      prevButton.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');

      nextButton.style.opacity = nextDisabled ? '0.5' : '1';
      nextButton.style.pointerEvents = nextDisabled ? 'none' : 'auto';
      nextButton.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');

      updateScrollIndicator();
    }

    function slideNext() {
      if (isMobileViewport()) return;

      const { stepWidth, maxPosition } = getDesktopMetrics();

      if (currentPosition > maxPosition) {
        currentPosition = Math.max(currentPosition - stepWidth, maxPosition);
        updateSliderPosition();
      }
    }

    function slidePrev() {
      if (isMobileViewport()) return;

      const { stepWidth } = getDesktopMetrics();

      if (currentPosition < 0) {
        currentPosition = Math.min(currentPosition + stepWidth, 0);
        updateSliderPosition();
      }
    }

    // Add click event listeners
    prevButton.addEventListener('click', slidePrev);
    nextButton.addEventListener('click', slideNext);

    slider.addEventListener('touchstart', (e) => {
      if (isMobileViewport()) return;

      touchStartX = e.touches[0].clientX;
      touchEndX = touchStartX;
      isDragging = true;
    }, { passive: true });

    slider.addEventListener('touchmove', (e) => {
      if (!isDragging || isMobileViewport()) return;

      touchEndX = e.touches[0].clientX;
      const diff = touchStartX - touchEndX;
      const tempPosition = currentPosition - diff;
      const { maxPosition } = getDesktopMetrics();

      if (tempPosition <= 0 && tempPosition >= maxPosition) {
        slider.style.transform = `translateX(${tempPosition}px)`;
      }
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      if (!isDragging) return;

      isDragging = false;

      if (isMobileViewport()) return;

      const diff = touchStartX - touchEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          slideNext();
        } else {
          slidePrev();
        }
      } else {
        updateSliderPosition();
      }
    });

    slider.addEventListener('scroll', () => {
      if (isMobileViewport()) {
        updateScrollIndicator();
      }
    }, { passive: true });

    function syncSliderMode() {
      const isMobile = isMobileViewport();

      if (isMobile !== wasMobile) {
        currentPosition = 0;
        slider.style.transform = '';
        slider.scrollLeft = 0;
        wasMobile = isMobile;
      }

      updateSliderPosition();
    }

    // Initialize slider
    syncSliderMode();
    window.addEventListener('load', updateScrollIndicator, { once: true });

    // Recalculate on window resize
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        syncSliderMode();
      }, 250);
    });

    // Quick Add Button Functionality
    const quickAddButtons = document.querySelectorAll('.quick-add-button');
    quickAddButtons.forEach(button => {
      // Store original text
      button.dataset.originalText = button.textContent;
      
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        const productId = button.dataset.productId;
        const productCard = button.closest('.product-card');
        const pointsValue = productCard.querySelector('.points-value');
        
        try {
          // Add loading state
          button.textContent = 'Adding...';
          button.disabled = true;

          // Here you would typically make an API call to add the product to cart
          // For now, we'll just simulate a successful add
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          // Show success state
          button.textContent = 'Added!';
          button.style.backgroundColor = '#4CAF50';
          
          // Update points display if available
          if (pointsValue) {
            const currentPoints = parseInt(pointsValue.textContent);
            if (!isNaN(currentPoints)) {
              pointsValue.textContent = `${currentPoints} points earned!`;
              pointsValue.style.color = '#4CAF50';
            }
          }
          
          // Reset button after 2 seconds
          setTimeout(() => {
            button.textContent = button.dataset.originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
            if (pointsValue) {
              pointsValue.style.color = '';
            }
          }, 2000);
        } catch (error) {
          console.error('Error adding product:', error);
          button.textContent = 'Error';
          button.style.backgroundColor = '#ff4d4d';
          
          setTimeout(() => {
            button.textContent = button.dataset.originalText;
            button.style.backgroundColor = '';
            button.disabled = false;
          }, 2000);
        }
      });
    });
  });
/* rewards section */
